// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1810":"d7a7ca1e","6433":"82020103","8328":"aaf3038b"}[chunkId] + ".chunk.css";
};